import { IArchiveUnpackRequest } from '@topshots/core-models';
import { topshotsAPI } from '../../app/api';

const archivesApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    getArchives: build.query<string[], void>({
      query: () => ({
        url: 'archives',
        method: 'GET',
      }),
      providesTags: (result, error, page) =>
        result
          ? [
              // Provides a tag for each enquiry in the current page,
              // as well as the 'PARTIAL-LIST' tag.
              ...result.map((archive) => ({
                type: 'Archives' as const,
                id: archive,
              })),
              { type: 'Archives', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Archives', id: 'PARTIAL-LIST' }],
    }),
    getArchiveUploadUrl: build.mutation<{ url: string }, string>({
      query: (filename) => ({
        url: 'archives',
        method: 'POST',
        body: { filename },
      }),
    }),
    requestUnpack: build.mutation<
      { tid: string },
      Omit<IArchiveUnpackRequest, 'taskId'>
    >({
      query: (data) => ({
        url: 'archives/unpack',
        method: 'POST',
        body: data,
      }),
    }),
    deleteArchive: build.mutation<void, string>({
      query: (id) => ({
        url: `archives`,
        method: 'DELETE',
        params: { filename: id },
      }),
      invalidatesTags: (result, error, product) => [{ type: 'Archives' }],
    }),
  }),
});

export const {
  useGetArchivesQuery,
  useDeleteArchiveMutation,
  useGetArchiveUploadUrlMutation,
  useRequestUnpackMutation,
} = archivesApi;
